import { apiFetch } from './client';

export type RequestEmailLoginInput = { email: string; fullName?: string };
export type RequestEmailLoginResult = { ok: true };

export type VerifyEmailLoginInput = { email: string; code: string; deviceId: string };
export type VerifyEmailLoginResult = { ok: true; expiresAt: number };

export function requestEmailLogin(input: RequestEmailLoginInput): Promise<RequestEmailLoginResult> {
  return apiFetch('/api/auth/email', { method: 'POST', json: input });
}

export function verifyEmailLogin(input: VerifyEmailLoginInput): Promise<VerifyEmailLoginResult> {
  return apiFetch('/api/auth/email/verify', { method: 'POST', json: input });
}

export function logout(): Promise<{ ok: true }> {
  return apiFetch('/api/auth/logout', { method: 'POST' });
}

export function refreshSession(): Promise<{ ok: true; expiresAt: number }> {
  return apiFetch('/api/auth/refresh', { method: 'POST' });
}
